import { render, staticRenderFns } from "./departments.vue?vue&type=template&id=806781c4&scoped=true&"
import script from "./departments.vue?vue&type=script&lang=ts&"
export * from "./departments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806781c4",
  null
  
)

export default component.exports